import { useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { apiKeysOptions } from './api';

const useTokenGeneration = (enabled: boolean) => {
  const [open, setOpen] = useState<boolean>(false);

  const { data: apiKeys = [], isError } = useQuery({
    ...apiKeysOptions.list(),
    enabled
  });

  return {
    apiKeys,
    open,
    setOpen,
    error: isError ? 'An error occurred. Please contact the General Index support team.' : ''
  };
};

export default useTokenGeneration;
